import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setAccountCollection = async (context) => {
  const body = { active: true };

  if (context.state.accountCollection && context.state.accountCollection.length > 0) {
    return;
  }

  const { data } = await api().post('finance.get-account', body);

  context.commit(types.SET_ACCOUNT_COLLECTION, data);
};
